<template>
  <div class="content-body">
    <QrCode
      ref="QrCode"
      :name="'QrCode'"
      @onQr="getQRSerial"
      :manual="true"
      :photo="camMode"
      @onPhoto="getCamRes"
    />
    <modalImg ref="imgzoomC" :name="'modalImg'" :arrImg="modalArr" />

    <ModalTaskCreate
      ref="ModalTaskCreate"
      :guid="dataProblem.guidProblem"
      :serials="dataProblem.serials"
      :comment="dataProblem.comment"
      :checks="dataProblem.checks"
      :address="dataProblem.address"
      :images="dataProblem.images"
      @onClose="afterCrTask"
    />

    <modalEq
      ref="modalEq"
      :title="$t('tasks.eqMethod.equipm')"
      :preSelected="dataProblem.serials"
      @onClose="getChoosenEq"
    ></modalEq>

    <ModalTaskInfo ref="taskInfo" />

    <vue-modal :on-close="closeModalMap" name="map-modal">
      <h5 slot="header" style="text-align: center">{{ modalMap.title }}</h5>
      <div class="row row-map">
        <GmapMap
          :center="modalMap.position"
          :zoom="17"
          map-type-id="terrain"
          style="height: 600px"
        >
          <GmapMarker
            :position="modalMap.position"
            :clickable="true"
            :draggable="true"
          />
        </GmapMap>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12 mb-3"></div>
      </div>
    </vue-modal>

    <!-- форма нової проблеми -->
    <div ref="newTaskCont" id="newTaskCont"></div>
    <div class="row match-height" v-if="cr_problem">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title" style="text-transform: none">
              <i class="icon-plus2"></i> {{ $t("problem.titles.add") }}
            </h4>
            <div class="heading-elements">
              <button
                type="button"
                class="btn btn-warning"
                @click="cr_problem = false"
                data-html="true"
                :title="$t('tasks.hint.close')"
              >
                <i style="color: #ffffff" class="icon-cross"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="card-block">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <h5>{{ $t("tasks.eqMethod.title") }}</h5>
                  </div>
                </div>
              </div>

              <div class="row mb-1">
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <button
                        type="button"
                        class="btn btn-primary btn-round"
                        @click="showModalQR()"
                        data-html="true"
                        :title="$t('equipm.hint.scanQr')"
                      >
                        <i class="icon-qrcode"></i>
                      </button>
                    </div>
                    <input
                      class="form-control border-primary"
                      :class="{
                        'border-danger': $v.dataProblem.serials.$error,
                      }"
                      type="text"
                      :placeholder="$t('equipm.table.serNumber')"
                      id="serial_enter"
                      v-model="dataProblem.serial"
                      @change="
                        addSerial({ serial: dataProblem.serial, address: null })
                      "
                      v-on:keyup.enter="
                        addSerial({ serial: dataProblem.serial, address: null })
                      "
                    />
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-warning btn-round"
                        @click="
                          addSerial({
                            serial: dataProblem.serial,
                            address: null,
                          })
                        "
                      >
                        <i style="color: #ffffff" class="icon-plus2"></i>
                        {{ $t("tasks.buttons.addSerial") }}
                      </button>
                    </div>
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-primary btn-round"
                        @click="showModalEq()"
                        data-html="true"
                        :title="$t('tasks.eqMethod.equipm')"
                      >
                        <i class="icon-list" style="color: white"></i>
                      </button>
                    </div>
                  </div>
                  <span
                    style="color: red"
                    class="d-flex"
                    v-if="$v.dataProblem.serials.$error"
                    >{{ $t("tasks.errors.entrSerial") }}</span
                  >
                </div>
              </div>

              <div class="row mb-1" v-if="dataProblem.serials.length > 0">
                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <button
                      type="button"
                      class="btn btn-danger btn-round"
                      @click="clearSelEq()"
                      v-if="dataProblem.serials.length > 1"
                    >
                      <i class="icon-bin"></i> {{ $t("tasks.buttons.remove") }}
                    </button>
                    <span
                      v-for="(serial, index) in dataProblem.serials"
                      :key="index"
                      class="btn tag-default btn-warning"
                      style="margin: 0.2rem"
                    >
                      {{ serial.serial }}
                      <a v-on:click="dataProblem.serials.splice(index, 1)"
                        ><i class="icon-bin"></i
                      ></a>
                    </span>
                  </div>
                </div>
              </div>

              <div class="row mb-1" v-if="dataProblem.checks.length > 0">
                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <h5>{{ $t("problem.table.probl_categ") }}</h5>
                  </div>
                </div>

                <div
                  class="col-md-3"
                  v-for="(gr, ind) in dataProblem.checks"
                  :key="ind"
                >
                  <div
                    v-for="(ch, index) in gr"
                    :key="index"
                    class="hand"
                    @click="ch.checked = !ch.checked"
                    style="margin: 10px 5px 10px 5px"
                  >
                    <i
                      :class="[
                        ch.checked
                          ? 'icon-checkbox-checked'
                          : 'icon-checkbox-unchecked',
                      ]"
                      style="vertical-align: middle"
                    ></i>
                    <i
                      style="vertical-align: middle; margin-left: 5px"
                      class="font-large-1"
                      :class="ch.class"
                    ></i>
                    <span
                      style="
                        vertical-align: middle;
                        font-size: 1.3em;
                        max-width: 80%;
                        margin-left: 5px;
                      "
                    >
                      {{ $t(ch.title) }}</span
                    >
                  </div>
                </div>
              </div>

              <!-- <div class="form-group">
                                <fieldset class="form-group position-relative has-icon-left">
                                    <textarea id="comment" rows="3" class="form-control border-primary" name="comment" :placeholder="$t('tasks.table.comment')" v-model="dataProblem.comment"></textarea>
                                    <div class="form-control-position">
                                        <i class="icon-file-text"></i>
                                    </div>
                                </fieldset>
                            </div> -->
              <div class="form-group position-relative has-icon-left">
                <textarea
                  id="comment"
                  rows="3"
                  class="form-control border-primary"
                  name="comment"
                  :class="{ 'border-danger': $v.dataProblem.comment.$error }"
                  :placeholder="$t('tasks.table.comment')"
                  v-model.trim="$v.dataProblem.comment.$model"
                ></textarea>
                <div class="form-control-position">
                  <i class="icon-file-text"></i>
                </div>
                <span v-if="$v.dataProblem.comment.$error" style="color: red">
                  <span
                    class="d-flex"
                    v-if="!$v.dataProblem.comment.required"
                    >{{ $t("errors.required") }}</span
                  >
                  <span class="d-flex" v-if="!$v.dataProblem.comment.minLength"
                    >{{ $t("errors.minLength") }}
                    {{ $v.dataProblem.comment.$params.minLength.min }}</span
                  >
                </span>
              </div>

              <div class="">
                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-images2"></i> {{ $t("tasks.table.images") }}
                  </h4>

                  <div class="form-group">
                    <input
                      type="file"
                      name="file"
                      id="file"
                      class="inputfile"
                      multiple="multiple"
                      accept="image/x-png,image/jpeg"
                      @change="onUploadImg"
                    />
                    <label id="file_loader" for="file">
                      <a class="btn btn-primary btn-min-width"
                        ><i class="icon-upload3"></i>
                        {{ $t("tasks.buttons.file") }}</a
                      >
                    </label>

                    <button
                      type="button"
                      class="btn btn-warning"
                      @click="
                        camMode = true;
                        showModalQR();
                      "
                      data-html="true"
                      :title="$t('equipm.hint.camera')"
                    >
                      <i style="color: #ffffff" class="icon-camera8"></i>
                      {{ $t("tasks.buttons.photo") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger"
                      @click="
                        dataProblem.images = [];
                        dataProblem.images2 = [];
                      "
                      v-if="dataProblem.images.length > 0"
                    >
                      <i class="icon-bin"></i> {{ $t("tasks.buttons.remove") }}
                    </button>
                  </div>

                  <div class="row">
                    <div
                      class="col-md-12"
                      style="display: flex; flex-wrap: wrap"
                    >
                      <span
                        style="color: red"
                        class="d-flex"
                        v-if="$v.dataProblem.images.$error"
                        >{{ $t("errors.filesEmpty") }}</span
                      >
                      <div
                        class="col-xs-3"
                        style="
                          padding: 0;
                          display: flex;
                          flex-direction: column;
                          align-content: center;
                          justify-content: center;
                          margin-bottom: 1em;
                        "
                        v-for="(image, index) in dataProblem.images"
                        :key="index"
                      >
                        <div class="card hand mb-0" style="margin-left: 5px">
                          <div class="w-100 h-100">
                            <i
                              class="icon-cross delete-image-icon"
                              @click="
                                dataProblem.images.splice(index, 1);
                                dataProblem.images2.splice(index, 1);
                              "
                              data-html="true"
                              :title="$t('tasks.hint.delImg')"
                            ></i>
                            <img
                              v-bind:src="image.data"
                              style="max-width: 100%; max-height: 100%"
                              @click="expandDiv(dataProblem.images, index)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <form class="form">
                <div class="form-actions right">
                  <button
                    type="button"
                    class="btn btn-warning"
                    @click="createProblem()"
                  >
                    <i style="color: #ffffff" class="icon-checkmark22"></i>
                    {{ $t("problem.btns.create") }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- форма нової проблеми -->

    <!-- форма info проблеми -->
    <div ref="infoCont" id="infoCont"></div>
    <div class="row" v-if="showinfo">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4
              class="form-section"
              style="text-transform: uppercase; max-width: 80%"
            >
              <i class="icon-info"></i>
              <span
                class="tag"
                :class="$t(dataProblem.status.str + '.class')"
                >{{ $t(dataProblem.status.str + ".title") }}</span
              >
              {{ dataProblem.dateCreate }}
            </h4>
            <div class="heading-elements">
              <button
                type="button"
                class="btn btn-warning"
                @click="showinfo = false"
                data-html="true"
                :title="$t('tasks.hint.close')"
              >
                <i style="color: #ffffff" class="icon-cross"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="card-block">
              <!-- <div class="row" v-if="dataProblem.status.id == 1">
                <div class="col-md-12 mb-1">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="showModalTCr()"
                  >
                    <i style="color: #ffffff" class="icon-plus2"></i>
                    {{ $t("tasks.buttons.create") }}
                  </button>
                </div>
              </div> -->

              <div
                class="d-flex flex-row mb-1"
                v-if="dataProblem.taskGuid && dataProblem"
              >
                <h5>
                  {{ $t("tasks.titles.task") + ":" }}
                  <button
                    type="button"
                    class="btn btn-warning"
                    @click="showModalTaskinfo(dataProblem.taskGuid)"
                  >
                    {{ dataProblem.taskNumber }}
                  </button>

                  <!-- <button
                    v-if="!dataProblem.mspId"
                    type="button"
                    class="btn btn-success"
                    @click="clickCrTask"
                  >
                    {{ $t("tasks.titles.reklamCreate") }}
                  </button> -->
                  <button
                    v-if="dataProblem.mspId"
                    type="button"
                    class="btn btn-success"
                    @click="clickMSPTask"
                  >
                    {{ $t("tasks.titles.openExtTask") }}
                  </button>
                </h5>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <h5>{{ $t("tasks.eqMethod.title") }}</h5>
                  </div>
                  <div class="form-group">
                    <span
                      v-for="(serial, index) in dataProblem.serials"
                      :key="index"
                      class="tag tag-default tag-warning"
                      style="margin: 0.2rem"
                    >
                      {{ serial }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <h5>{{ $t("tasks.table.comment") }}</h5>
                  <fieldset class="form-group position-relative has-icon-left">
                    <textarea
                      id="comment"
                      rows="3"
                      class="form-control border-primary"
                      name="comment"
                      :placeholder="$t('tasks.table.comment')"
                      v-model="dataProblem.comment"
                      disabled
                    ></textarea>
                    <div class="form-control-position">
                      <i class="icon-file-text"></i>
                    </div>
                  </fieldset>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <form class="form">
                    <h4 class="form-section">
                      <i class="icon-images2"></i>
                      {{ $t("tasks.table.images") }}
                    </h4>
                  </form>

                  <div class="row">
                    <div
                      class="col-md-12"
                      style="display: flex; flex-wrap: wrap"
                    >
                      <div
                        class="col-xs-2"
                        style="
                          padding: 0;
                          display: flex;
                          flex-direction: column;
                          align-content: center;
                          justify-content: center;
                          margin-bottom: 1em;
                        "
                        v-for="(image, index) in dataProblem.images"
                        :key="index"
                      >
                        <div class="card hand mb-0" style="margin-left: 5px">
                          <div class="w-100 h-100">
                            <i
                              class="icon-cross delete-image-icon"
                              v-if="cr_problem"
                              @click="
                                dataProblem.images.splice(index, 1);
                                dataProblem.images2.splice(index, 1);
                              "
                              data-html="true"
                              :title="$t('tasks.hint.delImg')"
                            ></i>
                            <img
                              :src="image"
                              style="max-width: 100%; max-height: 100%"
                              @click="expandDiv(dataProblem.images, index)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mb-1" v-if="dataProblem.checks.length > 0">
                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <h5>{{ $t("problem.table.probl_categ") }}</h5>
                  </div>
                </div>

                <div
                  class="col-md-3"
                  v-for="(gr, ind) in dataProblem.checks"
                  :key="ind"
                >
                  <i
                    style="vertical-align: middle; margin-left: 5px"
                    class="font-large-1"
                    :class="gr.class"
                  ></i>
                  <span
                    style="
                      vertical-align: middle;
                      font-size: 1.3em;
                      max-width: 80%;
                      margin-left: 5px;
                    "
                  >
                    {{ $t(gr.title) }}</span
                  >
                </div>
              </div>

              <div
                class="row"
                v-if="dataProblem.reasonComment && !dataProblem.precancel"
              >
                <div class="col-md-12 mb-1">
                  <h5>{{ $t("tasks.table.commCancel") }}</h5>
                  <div class="form-group mb-0">
                    <div class="position-relative has-icon-left">
                      <textarea
                        id="reasonCommentent"
                        name="reasonCommentent"
                        rows="3"
                        class="form-control border-primary"
                        v-model="dataProblem.reasonComment"
                        :class="{
                          'border-danger': $v.dataProblem.reasonComment.$error,
                        }"
                        disabled
                      ></textarea>
                      <div class="form-control-position">
                        <i class="icon-file-text"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mb-1" v-if="dataProblem.status.id == 1">
                <div class="col-md-12 mb-1" v-if="dataProblem.precancel">
                  <div class="form-group mb-0">
                    <div class="position-relative has-icon-left">
                      <textarea
                        id="reasonCommentent"
                        name="reasonCommentent"
                        rows="3"
                        class="form-control border-primary"
                        v-model.trim="$v.dataProblem.reasonComment.$model"
                        v-bind:placeholder="$t('tasks.table.commCancel')"
                        :class="{
                          'border-danger': $v.dataProblem.reasonComment.$error,
                        }"
                      ></textarea>
                      <div class="form-control-position">
                        <i class="icon-file-text"></i>
                      </div>
                    </div>
                  </div>
                  <span
                    v-if="$v.dataProblem.reasonComment.$error"
                    style="color: red"
                  >
                    <span class="d-flex">{{ $t("errors.required") }}</span>
                  </span>
                </div>
                <div class="col-md-12">
                  <div class="d-flex" style="justify-content: flex-end">
                    <button
                      type="button"
                      class="btn btn-danger"
                      v-if="!dataProblem.precancel"
                      @click="dataProblem.precancel = true"
                    >
                      {{ $t("equipm.buttons.cancel") }}
                    </button>
                    <button
                      v-if="dataProblem.precancel"
                      type="button"
                      class="btn btn-danger"
                      @click="changeProblem()"
                    >
                      {{ $t("equipm.buttons.cancel") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- форма info проблеми -->

    <!-- таблиця -->
    <div class="row match-height">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">
              <i class="icon-bubble2"></i> {{ $t("titles.problem") }}
            </h3>
            <div class="heading-elements">
              <button
                type="button"
                class="btn btn-warning"
                v-if="
                  $store.state.listRole.roleCourier ||
                  $store.state.listRole.client ||
                  $store.state.listRole.dispatcher ||
                  $store.state.listRole.admin
                "
                @click="newProblem()"
              >
                <i style="color: #ffffff" class="icon-plus2"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="card-block pt-0">
              <div class="row">
                <div class="col-md-12">
                  <div class="col-form-label-lg">
                    <fieldset class="position-relative">
                      <input
                        type="text"
                        class="form-control form-control input"
                        placeholder=""
                        v-model="filterStr"
                      />
                      <div class="form-control-position">
                        <i class="icon-search4 font-medium-4"></i>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>

              <div class="mobileTbl table-responsive">
                <table class="table table-hover mb-0" cellspacing="0">
                  <thead>
                    <tr>
                      <th style="vertical-align: middle">
                        {{ $t("tasks.table.status") }}
                      </th>
                      <th class="text-truncate" style="vertical-align: middle">
                        {{ $t("tasks.table.date") }}
                        <a @click="sortData('dt')"><i class="icon-sort"></i></a>
                      </th>
                      <th style="vertical-align: middle">
                        {{ $t("equipm.table.serNumber") }}
                        <a @click="sortData('serial')"
                          ><i class="icon-sort"></i
                        ></a>
                      </th>
                      <th style="vertical-align: middle">
                        {{ $t("problem.table.descr") }}
                      </th>
                      <th style="vertical-align: middle" class="text-truncate">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(eq, index) in paginatedData"
                      :key="index"
                      class="hand"
                      @click="getInfoProblem(eq.guid)"
                    >
                      <td :data-title="$t('tasks.table.status')">
                        <div>{{ eq.id }}</div>
                        <div v-if="eq.status != null">
                          <span
                            class="tag"
                            :class="$t(eq.status.str + '.class')"
                            >{{ $t(eq.status.str + ".title") }}</span
                          >
                        </div>
                        <div v-if="eq.client">{{ eq.client }}</div>
                      </td>
                      <td
                        class="text-truncate"
                        :data-title="$t('tasks.table.date')"
                      >
                        <span class="hand">{{ eq.dateCreate }}</span>
                      </td>
                      <td
                        class="text-truncate"
                        :data-title="$t('equipm.table.serNumber')"
                      >
                        <a
                          v-if="eq.coordinate.lng != null"
                          class="hand"
                          @click.self="showModalMap($event, eq)"
                          >{{ eq.serial }} <i class="icon icon-location2"></i
                        ></a>
                        <span v-else>{{ eq.serial }}</span>
                      </td>
                      <td :data-title="$t('problem.table.descr')" class="">
                        <span>{{ eq.description }}</span>
                      </td>
                      <td class="text-truncate">
                        <div
                          class="row"
                          style="float: right; margin-right: 5px"
                        >
                          <div class="btn-group">
                            <button
                              type="button"
                              class="btn btn-warning"
                              @click.stop="getInfoProblem(eq.guid)"
                            >
                              <i class="icon-info"></i>
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="" style="text-align: center">
                <ul class="pagination">
                  <li class="page-item" v-if="pageNumber > 0">
                    <a class="page-link" @click="pageNumber--"
                      ><i class="icon-arrow-left2"></i
                    ></a>
                  </li>

                  <li
                    class="page-item"
                    v-bind:class="{ active: pageNumber == page - 1 }"
                    v-for="(page, index) in pages"
                    :key="index"
                  >
                    <a
                      v-if="page != '...'"
                      class="page-link"
                      @click="pageNumber = page - 1"
                      >{{ page }}</a
                    >
                    <a v-else class="page-link" :id="index">{{ page }}</a>
                  </li>

                  <li class="page-item" v-if="pageNumber < pageCount - 1">
                    <a class="page-link" @click="pageNumber++"
                      ><i class="icon-arrow-right2"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- таблиця -->
  </div>
</template>

<script>
import { required, minLength, sameAs, email } from "vuelidate/lib/validators";

export default {
  name: "Appeals",
  data() {
    return {
      errors: [],
      listProblems: [],

      camMode: false,

      cr_problem: false,
      showinfo: false,

      dataProblem: {
        guidProblem: "",
        serials: [],
        serial: null,
        comment: null,
        dateCreate: null,
        coordinate: {
          latitude: null,
          longitude: null,
          accuracy: null,
        },
        status: { str: null, id: null },
        images: [],
        images2: [],
        checks: [],

        taskNumber: null,
        taskGuid: null,

        precancel: false,
        reasonComment: null,
      },

      //sorting filtering
      filterStr: "",
      sortKey: "dt",
      direction: "desc",
      boolDir: true,
      classSort: "icon-sort-amount-asc",
      showFiltr: false,
      filterStatusClass: {
        left: "-200px",
        top: "-200px",
      },

      pageNumber: 0, //pagination

      filesLimit: 24,

      modalArr: [],

      showTypes: false,
      choosedType: 3,

      categories: [],

      modalMap: {
        position: { lat: null, lng: null },
        title: "",
      },
    };
  },
  validations: {
    dataProblem: {
      reasonComment: {
        required,
        minLength: minLength(4),
      },
      serials: { required, minLength: minLength(1), $each: { required } },
      comment: { required, minLength: minLength(4) },
      images: { required, minLength: minLength(1), $each: { required } },
    },
  },
  props: {
    //pagination
    size: {
      type: Number,
      required: false,
      default: 10,
    },
    paggSize: {
      type: Number,
      required: false,
      default: 5,
    },
  },
  methods: {
    onUploadImg(e) {
      let tt = null;
      let _this = this;
      if (e.target.files.length > 0) {
        for (let i = 0; i < e.target.files.length; i++) {
          const element = e.target.files[i];
          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = (e) => {
            var img = new Image();
            img.onload = function () {
              if (img.width > 1500) {
                //зжимання
                var w = img.width;
                var h = img.height;
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d"); // Создаем узел атрибута
                var anw = document.createAttribute("width");
                anw.nodeValue = w;
                var anh = document.createAttribute("height");
                anh.nodeValue = h;
                canvas.setAttributeNode(anw);
                canvas.setAttributeNode(anh);
                ctx.drawImage(img, 0, 0, w, h);
                // Чем меньше значение .7, тем более размытым будет нарисованное изображение
                var base64Img = canvas.toDataURL("image/jpeg", 0.6);
                //зжимання

                tt = base64Img.split(",");
              } else {
                tt = img.src.split(",");
              }

              let err = false;
              if (_this.cr_problem) {
                if (_this.dataProblem.images.length < _this.filesLimit) {
                  let name =
                    "newProblem_" + Math.floor(Math.random() * 4999) + ".png";
                  _this.dataProblem.images.push({
                    name: name,
                    data: tt[0] + "," + tt[1],
                  });
                  _this.dataProblem.images2.push({ name: name, data: tt[1] });
                } else {
                  err = true;
                }
              }
              if (err) {
                _this.$notify({
                  group: "info",
                  title: "Warning",
                  text: "Ліміт файлів " + _this.filesLimit + 1,
                });
              }
            };
            img.src = e.target.result;
          };
        }
      }
    },
    getCamRes(dataCam) {
      this.camMode = false;
      if (this.isValid(dataCam)) {
        if (this.cr_problem) {
          let name = "newProblem_" + Math.floor(Math.random() * 4999) + ".png";
          this.dataProblem.images.push({ name: name, data: dataCam });
          this.dataProblem.images2.push({
            name: name,
            data: dataCam.split(",")[1],
          });
        } else {
          //ModalTaskCreate
          this.$refs.ModalTaskCreate.getCamResCh(dataCam);
        }
      }
    },
    getListCategories(guidEq) {
      let categories = [];

      return new Promise((resolve, reject) => {
        let dataRequest = {
          guid: guidEq,
        };
        this.makeQuery("/service/getListProblemEquipment", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            for (let i = 0; i < result.length; i++) {
              for (let j = 0; j < this.$store.state.categories.length; j++) {
                if (
                  parseFloat(result[i].icon) ==
                  this.$store.state.categories[j].id
                ) {
                  categories.push({
                    id: this.$store.state.categories[j].id,
                    guid: result[i].guid,
                    title: this.$store.state.categories[j].title,
                    class: this.$store.state.categories[j].class,
                    checked: false,
                  });
                  break;
                }
              }
            }
            return resolve(categories);
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
            return reject(result);
          });
      });
    },
    getlistProblems() {
      this.listProblems = [];
      let dataRequest = { guidClient: this.$store.state.guidClient };

      this.makeQuery("/service/getListProblem", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (result != null) {
            let resData = result;
            let lat = null,
              lng = null;

            for (let i = 0; i < resData.length; i++) {
              resData[i].dt = Math.round(new Date(result[i].dateCreate));
              resData[i].dateCreate = this.dtFormat(resData[i].dateCreate);

              if (
                resData[i].coordinate != undefined &&
                resData[i].coordinate != "" &&
                resData[i].coordinate.length > 4 &&
                resData[i].coordinate != null
              ) {
                resData[i].coordinate = resData[i].coordinate.replace(
                  ", ",
                  ":"
                );
                var coord = resData[i].coordinate.split(":");
                if (coord[0].indexOf(",") > -1) {
                  lat = coord[0].replace(",", ".");
                } else {
                  lat = coord[0];
                }
                lat = parseFloat(lat);

                if (coord[1].indexOf(",") > -1) {
                  lng = coord[1].replace(",", ".");
                } else {
                  lng = coord[1];
                }
                lng = parseFloat(lng);

                resData[i].coordinate = { lat: lat, lng: lng };
              } else {
                resData[i].coordinate = { lat: null, lng: null };
              }

              if (resData[i].status != undefined) {
                if (resData[i].status == 1) {
                  resData[i].status = {
                    str: "tasks.statuses.new",
                    id: resData[i].status,
                  };
                } else if (resData[i].status == 2) {
                  resData[i].status = {
                    str: "tasks.statuses.process",
                    id: resData[i].status,
                  };
                } else if (resData[i].status == 3) {
                  resData[i].status = {
                    str: "tasks.statuses.done",
                    id: resData[i].status,
                  };
                } else if (resData[i].status == 4) {
                  resData[i].status = {
                    str: "tasks.statuses.cancel",
                    id: resData[i].status,
                  };
                }
              }

              this.listProblems.push(resData[i]);
            }
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
          console.log(result);
        });
    },
    getInfoProblem(guid) {
      this.clearDataProbl();
      let dataRequest = { guid: guid };

      this.makeQuery2("/service/getInfoProblem", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (!result || !result.data || !result.data.data) {
            this.showNotification("custom-error", "Error", result);
            return;
          }
          this.dataProblem.guidProblem = guid;

          let serials = result.data.data.serial.split(",");
          for (let i = 0; i < serials.length; i++) {
            this.dataProblem.serials.push(serials[i]);
          }

          this.dataProblem.comment = result.data.data.description;
          this.dataProblem.dateCreate = this.dtFormat(
            result.data.data.dateCreate
          );
          //this.dataProblem.position.latitude = ;
          //this.dataProblem.position.longitude = ;

          if (result.data.data.task) {
            this.dataProblem.taskNumber = result.data.data.task.name;
            this.dataProblem.taskGuid = result.data.data.task.id;
            this.dataProblem.mspId = result.data.data.task.msp_id
              ? result.data.data.task.msp_id
              : null;
          }

          this.dataProblem.checks = [];
          /*if(result.categories != undefined){

                            for (let i = 0; i < result.categories.length; i++) {
                                for (let j = 0; j < this.$store.state.categories.length; j++) {
                                    if(this.$store.state.categories[j].id == result.categories[i].id){
                                        //this.categories[j].checked = result.categories[i].value;
                                        if(result.categories[i].value == true){
                                            this.dataProblem.checks.push({
                                                id: this.$store.state.categories[j].id,
                                                guid: result.categories[i].guidProblemEquipment,
                                                title: this.$store.state.categories[j].title,
                                                class: this.$store.state.categories[j].class,
                                                checked: result.categories[i].value
                                            });
                                        }
                                        break;
                                    }
                                }
                            }

                        }*/
          if (result.data.data.status != undefined) {
            if (result.data.data.status == 1) {
              this.dataProblem.status.str = "tasks.statuses.new";
              this.dataProblem.status.id = result.data.data.status;
            } else if (result.data.data.status == 2) {
              this.dataProblem.status.str = "tasks.statuses.process";
              this.dataProblem.status.id = result.data.data.status;
            } else if (result.data.data.status == 3) {
              this.dataProblem.status.str = "tasks.statuses.done";
              this.dataProblem.status.id = result.data.data.status;
            } else if (result.data.data.status == 4) {
              this.dataProblem.status.str = "tasks.statuses.cancel";
              this.dataProblem.status.id = result.data.data.status;
            }
          }

          let arr_img = [],
            mark_old = false;

          if (
            result &&
            result.data &&
            result.data.data &&
            result.data.data.signed_urls &&
            Array.isArray(result.data.data.signed_urls)
          ) {
            arr_img = result.data.data.signed_urls;
          }
          if (
            result &&
            result.data &&
            result.data.data &&
            result.data.data.files &&
            Array.isArray(result.data.data.files)
          ) {
            arr_img = result.data.data.files;
            mark_old = true;
          }
          if (arr_img.length) {
            for (let i = 0; i < arr_img.length; i++) {
              if (mark_old) {
                this.dataProblem.images.push(arr_img[i].link + "/preview");
              } else {
                this.dataProblem.images.push(arr_img[i].url);
              }
            }
          }

          if (result.data.data.AbortComment) {
            this.dataProblem.reasonComment = result.data.data.AbortComment;
          }

          this.showinfo = true;
          this.cr_problem = false;

          this.anchorTo("infoCont");
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    newProblem() {
      this.showNotification(
        "custom-info",
        "Функціонал недоступний",
        "Сервіс Мodern Expo переходить на нову платформу. Будь ласка, зареєструйте своє звернення за <a class='bold' style='text-decoration: underline;' href='https://sp.modern-expo.com/public/form/ecbb669bb776adcf'> цим посиланням </a>",
        -1
      );
      // if (this.showinfo) {
      //   this.showinfo = false;
      // }
      // this.cr_problem = true;

      // this.anchorTo("newTaskCont");

      // this.getGPS()
      //   .then((result) => {
      //     this.dataProblem.coordinate.latitude = result.latitude;
      //     this.dataProblem.coordinate.longitude = result.longitude;
      //     this.dataProblem.coordinate.accuracy = result.accuracy;
      //   })
      //   .catch((err) => {
      //     this.showNotification("custom-error", "Geolocation", err.message);
      //   });

      // this.dataProblem.checks = [];
      // if (this.categories.length > 0) {
      //   let arr = this.categories;
      //   let checker = 0;
      //   this.dataProblem.checks.push([]);

      //   for (let j = 0; j < arr.length; j++) {
      //     if (this.dataProblem.checks[checker].length < 4) {
      //       this.dataProblem.checks[checker].push(arr[j]);
      //     } else {
      //       checker = checker + 1;
      //       this.dataProblem.checks.push([]);
      //       this.dataProblem.checks[checker].push(arr[j]);
      //     }
      //   }
      // }
    },
    createProblem() {
      return;
      this.$v.dataProblem.serials.$touch();
      this.$v.dataProblem.comment.$touch();
      this.$v.dataProblem.images.$touch();

      if (
        !this.$v.dataProblem.serials.$error &&
        !this.$v.dataProblem.comment.$error &&
        !this.$v.dataProblem.images.$error
      ) {
        this.$v.dataProblem.serials.$reset();
        this.$v.dataProblem.comment.$reset();
        this.$v.dataProblem.images.$reset();

        let checks = [];
        //прохід по dataProblem.checks
        for (let i = 0; i < this.dataProblem.checks.length; i++) {
          for (let j = 0; j < this.dataProblem.checks[i].length; j++) {
            if (this.dataProblem.checks[i][j].checked) {
              checks.push(this.dataProblem.checks[i][j].guid);
            }
          }
        }
        let arrS = "";
        for (let i = 0; i < this.dataProblem.serials.length; i++) {
          arrS = arrS + this.dataProblem.serials[i].serial + ",";
        }
        arrS = arrS.slice(0, -1);

        let dataRequest = {
          serial: arrS,
          comment: this.dataProblem.comment,
          coordinate: this.dataProblem.coordinate,
          address: this.dataProblem.serials[0].address,
          images: this.dataProblem.images,
          images2: this.dataProblem.images2,
          categories: checks,
        };

        this.makeQuery("/service/addProblem", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            this.showNotification(
              "custom-success",
              this.$t("titles.problem"),
              this.$t("problem.titles.add") + " " + result.problem_id
            );
            this.getlistProblems();
            this.clearDataProbl();

            if (this.showinfo) {
              this.showinfo = false;
            }
            this.cr_problem = false;
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },
    getQRSerial(serial) {
      if (this.cr_problem) {
        this.addSerial({ serial: serial, address: null });
      }
    },
    addSerial(payload) {
      let ps = payload;
      if (this.isValid(ps.serial)) {
        let ser = this.checkPattSer(ps.serial);
        if (ser) {
          ps.serial = ser;
        } else {
          this.dataProblem.serial = null;
          return;
        }

        let ind_find = null;
        for (let i = 0; i < this.dataProblem.serials.length; i++) {
          if (ps.serial == this.dataProblem.serials[i].serial) {
            //serial
            ind_find = i;
            break;
          }
        }

        if (ind_find == null) {
          if (ps.address != null) {
            this.dataProblem.serials.push(ps);
          } else {
            let dataRequest = {
              serial: ps.serial,
              userGuid: this.$store.getters.getGuidUser,
              guidClient: this.$store.state.guidClient,
            };
            this.makeQuery("/service/productSerialSite", {
              dataRequest: dataRequest,
              token: this.$store.getters.getUserToken,
            })
              .then((result) => {
                if (result.Adress != undefined) {
                  ps.address = result.Adress;
                  this.dataProblem.serials.push(ps);
                }
              })
              .catch((result) => {
                this.showNotification("custom-error", "Error", result);
              });
          }
        }
        this.dataProblem.serial = null;
      }
    },
    sortData(key) {
      if (this.sortKey == key) {
        this.boolDir = !this.boolDir;
      } else {
        this.boolDir = false;
      }
      if (this.boolDir) {
        this.direction = "asc";
        this.classSort = "icon-sort-amount-asc";
      } else {
        this.direction = "desc";
        this.classSort = "icon-sort-amount-desc";
      }

      this.sortKey = key;
    },
    clearDataProbl() {
      this.$v.$reset();

      this.dataProblem.serial = null;
      this.dataProblem.guidProblem = "";
      this.dataProblem.serials = [];
      this.dataProblem.images = [];
      this.dataProblem.images2 = [];
      this.dataProblem.comment = null;
      this.dataProblem.coordinate.latitude = null;
      this.dataProblem.coordinate.longitude = null;
      this.dataProblem.coordinate.accuracy = null;
      this.dataProblem.dateCreate = null;
      this.dataProblem.status.id = null;
      this.dataProblem.status.str = null;
      this.dataProblem.taskNumber = null;
      this.dataProblem.taskGuid = null;

      this.dataProblem.precancel = false;
      this.dataProblem.reasonComment = null;

      for (let i = 0; i < this.categories.length; i++) {
        this.categories[i].checked = false;
      }
    },
    base64String(file, data) {
      let mediatype = "";

      const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      };

      if (file.indexOf(".xlsx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      } else if (file.indexOf(".xls") > -1) {
        mediatype = "application/vnd.ms-excel";
      } else if (file.indexOf(".txt") > -1) {
        mediatype = "text/plain";
      } else if (file.indexOf(".xml") > -1) {
        mediatype = "text/xml";
      } else if (
        file.indexOf(".png") > -1 ||
        file.indexOf(".jpg") > -1 ||
        file.indexOf(".jpeg") > -1 ||
        file.indexOf(".png") > -1
      ) {
        mediatype = "image/png";
      } else if (file.indexOf(".pdf") > -1) {
        mediatype = "application/pdf";
      } else if (file.indexOf(".doc") > -1) {
        mediatype = "application/msword";
      } else if (file.indexOf(".docx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else if (file.indexOf(".gz") > -1) {
        mediatype = "application/gzip";
      } else if (file.indexOf(".rar") > -1) {
        mediatype = "application/vnd.rar";
      } else if (file.indexOf(".tar") > -1) {
        mediatype = "application/x-tar";
      } else if (file.indexOf(".ppt") > -1) {
        mediatype = "application/vnd.ms-powerpoint";
      } else if (file.indexOf(".pptx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      } else if (file.indexOf(".vsd") > -1) {
        mediatype = "application/vnd.visio";
      } else if (file.indexOf(".zip") > -1) {
        mediatype = "application/zip";
      }

      if (mediatype != "") {
        return b64toBlob(data, mediatype); //'data:' + mediatype + ';base64,';
      } else {
        return null;
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    expandDiv(arr, ind) {
      if (arr[0].data != undefined) {
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          arr2.push(arr[i].data);
        }
        arr = arr2;
      }

      $("#modalImg").modal("show");
      this.$refs.imgzoomC.onShow(ind, arr);
    },
    clearSelEq() {
      this.dataProblem.serials = [];
    },
    closeEqChoose() {},
    getChoosenEq(payload) {
      for (let i = 0; i < payload.result.length; i++) {
        this.addSerial(payload.result[i]);
      }
    },
    showModalEq() {
      this.$refs.modalEq.showFrom().then((result) => {
        $("#modalEq").modal("toggle");
      });
    },
    showModalMap(event, item) {
      if (!e) var e = window.event;
      e.cancelBubble = true;
      if (e.stopPropagation) e.stopPropagation();

      //запит по координати за серійнком
      if (item.coordinate.lng != null && item.coordinate.lat != null) {
        //resData[i].coordinate = {lat: null, lng: null};
        this.modalMap.position.lat = item.coordinate.lat;
        this.modalMap.position.lng = item.coordinate.lng;
        this.modalMap.title = "Map";
        this.$modals.show("map-modal");
      } else {
        this.showNotification(
          "custom-info",
          this.$t("equipm.table.location"),
          this.$t("errors.emptyGPS")
        );
      }
    },
    closeModalMap: function () {
      this.modalMap.position = { lat: 0, lng: 0 };
      this.$modals.hide("map-modal");
    },
    showModalTCr() {
      this.$modals.show("CreateTask");
      this.$refs.ModalTaskCreate.firstRun();
    },
    afterCrTask() {
      //змінити проблемі по гуіду статус
      for (let i = 0; i < this.listProblems.length; i++) {
        if (this.listProblems[i].guid == this.dataProblem.guidProblem) {
          this.listProblems[i].status.str = "tasks.statuses.process";
          this.listProblems[i].status.id = 2;
          break;
        }
      }

      this.showinfo = false;
      this.clearDataProbl();
    },
    showModalTaskinfo(guid) {
      this.$modals.show("InfoTask");
      this.$refs.taskInfo.getTaskInfo(guid);
    },
    changeProblem() {
      if (this.dataProblem.status.id == 1) {
        //status problem new
        this.$v.$touch();

        if (!this.$v.dataProblem.reasonComment.$error) {
          this.$v.$reset();

          let dataRequest = {
            guid: this.dataProblem.guidProblem,
            status: 4, //reject
            AbortComment: this.dataProblem.reasonComment,
          };
          this.makeQuery("/service/updateProblem", {
            dataRequest: dataRequest,
            token: this.$store.getters.getUserToken,
          })
            .then((result) => {
              if (result.problem_id) {
                this.showNotification(
                  "custom-success",
                  this.$t("history.statuses.cancel.title"),
                  result.problem_id,
                  -1
                );
              }
              this.showinfo = false;
              this.getlistProblems();
            })
            .catch((result) => {
              this.showNotification("custom-error", "Error", result);
            });
        }
      }
    },

    clickMSPTask() {
      window.open(
        "https://sp.modern-expo.com/crm/task/" + this.dataProblem.mspId
      );
    },
    clickCrTask() {
      this.makeQuery("/service/getinfotask", {
        dataRequest: {
          guidTask: this.dataProblem.taskGuid,
          quantityStart: 0,
          quantityFinish: 0,
        },
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (result != null && result.DocNumber != undefined) {
            this.dataProblem.task = result;

            let dataRequest = {
              email: this.$store.state.email,
              type: this.dataProblem.task.WorkType,
              serial: [],
              comment: this.dataProblem.task.Comment,
              jobs: this.dataProblem.task.WorkList,
              linksImages: this.dataProblem.images,
              arrayImage: [],
              address: this.dataProblem.task.Adress,
              taskNumber: this.dataProblem.taskNumber,
            };
            for (let i = 0; i < this.dataProblem.images.length; i++) {
              let nameF =
                "newTask_" + Math.floor(Math.random() * 4999) + ".png";
              dataRequest.arrayImage.push({
                data: this.dataProblem.images[i],
                name: nameF,
              });
            }
            this.dataProblem.task.ArrayGoods.map((eq) => {
              dataRequest.serial.push({
                serial: eq.SN.trim(),
                address: eq.City,
              });
            });

            this.makeQuery2(
              "/bitrixErp/hs/Upp/Upp_create",
              dataRequest,
              "https://bitrixerp.modern-expo.com"
            )
              .then((result2) => {
                if (result2 && result2.status) {
                  this.showNotification(
                    "custom-success",
                    "Success",
                    this.$t("tasks.titles.taskOtherCreated")
                  );

                  this.showinfo = false;
                  this.clearDataProbl();
                } else {
                  this.showNotification(
                    "custom-error",
                    this.$t("tasks.titles.taskOtherFail"),
                    result2
                  );
                }
              })
              .catch((result2) => {
                this.showNotification(
                  "custom-error",
                  this.$t("tasks.titles.taskOtherFail"),
                  result2
                );
              });
          }
        })
        .catch((result) => {
          this.showNotification(
            "custom-error",
            this.$t("tasks.titles.taskOtherFail"),
            result
          );
        });
    },
  },
  computed: {
    listFiltered: function () {
      let find = this.filterStr.toLowerCase();
      let keys = [];
      if (this.listProblems.length > 0) {
        keys = Object.keys(this.listProblems[0]);
      }

      this.pageNumber = 0;

      return this.listProblems.filter((item) => {
        for (let i = 0; i < keys.length; i++) {
          if (
            find == "" ||
            (item[keys[i]] != null &&
              typeof item[keys[i]] == "string" &&
              keys[i] != "GUID" &&
              item[keys[i]].toLowerCase().indexOf(find) > -1)
          ) {
            return item;
            break;
          }
        }
      });
    },
    pageCount() {
      let l = this.listFiltered.length,
        s = this.size;
      return Math.ceil(l / s);
    },
    pages: function () {
      let arr = [];
      for (let i = 0; i < this.pageCount; i++) {
        arr[i] = i + 1;
      }
      let divider = Math.trunc(this.paggSize / 2);
      let start = this.pageNumber - divider;
      let end = this.pageNumber + divider + 1;
      if (start < 0) {
        start = 0;
      }
      let final_arr = arr.slice(start, end);
      if (start + 1 > arr[0]) {
        final_arr.unshift("...");
      }
      if (end < arr[arr.length - 1]) {
        final_arr.push("...");
      }
      return final_arr;
    },
    paginatedData() {
      const start = this.pageNumber * this.size,
        end = start + this.size;
      return this.sortedData.slice(start, end); //listFiltered
    },
    sortedData: function () {
      return _.orderBy(this.listFiltered, this.sortKey, this.direction);
    },
    typeTitle: function () {
      for (let i = 0; i < this.$store.state.eq_type.length; i++) {
        if (this.choosedType == this.$store.state.eq_type[i].id) {
          return this.$t(this.$store.state.eq_type[i].translate);
        }
      }
    },
    lenSerial() {
      return this.dataProblem.serials.length;
    },
  },
  components: {},
  created() {
    this.checkAuthorized()
      .then((result) => {
        this.getlistProblems();

        //guidApp
        if (this.$route.params.guidApp != null) {
          //let guidApp = this.$route.params.guidApp;
          this.getInfoProblem(this.$route.params.guidApp);
        }
      })
      .catch((err) => {
        this.showNotification(
          "custom-error",
          this.$t("errors.title"),
          this.$t("errors.500")
        );
      });
  },
  mounted() {},
  beforeDestroy() {
    this.$root.$off();
  },
  watch: {
    cr_problem: function (newVal, prevVal) {
      if (newVal == true && prevVal == false) {
        this.clearDataProbl();
      }
    },
    lenSerial(value) {
      if (value == 1 && this.cr_problem) {
        this.dataProblem.checks = [];

        // this.getListCategories(result.GUID)
        // .then(result => {
        //     if(result.length > 0){
        //         let checker = 0;
        //         this.dataProblem.checks.push([]);
        //         for (let j = 0; j < result.length; j++) {
        //             if(this.dataProblem.checks[checker].length < 4){
        //                 this.dataProblem.checks[checker].push(result[j]);
        //             } else {
        //                 checker = checker + 1;
        //                 this.dataProblem.checks.push([]);
        //                 this.dataProblem.checks[checker].push(result[j]);
        //             }
        //         }
        //     }
        // });
      } else if (value == 0) {
        this.dataProblem.checks = [];
      }
    },
  },
};
</script>

<style scoped>
.border-danger {
  border: 3px solid #da4453 !important;
}

.col-xs-4 {
  padding: 0;
}
</style> 


// WEBPACK FOOTER //
// src/pages/Appeals.vue